/* eslint-disable import/prefer-default-export */
export const SOCKET_OPERATION_UPDATED = 'SOCKET_operationUpdated';

// zipUploadProgress
export const SOCKET_ZIP_UPLOAD_PROGRESS = 'SOCKET_zipUploadProgress';

// zipVerifyProgress
export const SOCKET_ZIP_VERIFY_PROGRESS = 'SOCKET_zipVerifyProgress';
